var r = ["script error.", "script error"], R = 5e3, E = 10, S = "script";
export {
  E as MAX_OPAQUE_REPORTS_PER_SESSION,
  r as OPAQUE_SCRIPT_ERROR_MESSAGES,
  R as RECENT_SCRIPT_WINDOW_MS,
  S as SCRIPT_RESOURCE_INITIATOR
};

//# sourceMappingURL=scriptErrorDiagnostics.constants.js.map